/**
 * Отступы боковых подключений гидравлического разделителя (left / right:
 * firstOffset, lastOffset, spacing) только для комбинированного узла
 * (CollectorWithSeparatorCharacteristicsCalculator).
 *
 * До указанного шага пресета кВт включительно эти значения подменяют left/right
 * из HYDRAULIC_SEPARATOR_CLIENT_PARAMS_TABLE. Одиночный гидроразделитель
 * (CharacteristicsCalculator) этот файл не использует.
 *
 * Задайте здесь свои числа под комбинированный узел; ключи — 40, 50, 60, 85, 135.
 */

/** Пресеты с большим ключом берут отступы только из общей таблицы гидроразделителя. */
export const CWS_HYDRAULIC_SEP_CLIENT_OFFSET_MAX_PRESET_KW = 135;

/**
 * @typedef {{ firstOffset: number, lastOffset: number, spacing: number }} CwsSepSideOffsets
 * @typedef {{ left: CwsSepSideOffsets, right: CwsSepSideOffsets }} CwsSepOffsetsRow
 */

/** @type {Object<number, CwsSepOffsetsRow>} */
export const CWS_HYDRAULIC_SEP_CLIENT_OFFSETS_BY_PRESET_KW = {
  40: {
    left: { firstOffset: 50, lastOffset: 50, spacing: 125 },
    right: { firstOffset: 67.5, lastOffset: 67.5, spacing: 90 },
  },
  50: {
    left: { firstOffset: 50, lastOffset: 50, spacing: 125 },
    right: { firstOffset: 67.5, lastOffset: 67.5, spacing: 90 },
  },
  60: {
    left: { firstOffset: 67, lastOffset: 67, spacing: 125 },
    right: { firstOffset: 67, lastOffset: 67, spacing: 125 },
  },
  85: {
    left: { firstOffset: 74.5, lastOffset: 74.5, spacing: 150 },
    right: { firstOffset: 74.5, lastOffset: 74.5, spacing: 150 },
  },
  135: {
    left: { firstOffset: 74.5, lastOffset: 74.5, spacing: 150 },
    right: { firstOffset: 74.5, lastOffset: 74.5, spacing: 150 },
  },
};

/**
 * Межосевое подача/обратка гребёнок (мм) для клиентских пресетов комбо-узла.
 * Иначе — collectorInteraxisFromSeparatorConnectionSpacingMm(шаг патрубков стрелки).
 */
export const CWS_COLLECTOR_PIPE_SPACING_MM_BY_PRESET_KW = {
  40: 90,
  50: 90,
};

export function getCwsCollectorPipeSpacingMm(presetKeyKw) {
  const v = CWS_COLLECTOR_PIPE_SPACING_MM_BY_PRESET_KW[presetKeyKw];
  return Number.isFinite(v) && v > 0 ? v : null;
}
